import fieldSubForm from '@grouper/modules/database/mixins/fieldSubForm'
import { notifyIf } from '@grouper/modules/core/utils/error'
import form from '@grouper/modules/core/mixins/form'
import FieldSelectOptions from '@grouper/modules/database/components/field/FieldSelectOptions'
import FieldService from '@grouper/modules/database/services/field'
import { randomColor } from '@grouper/modules/core/utils/colors'

export default {
  mixins: [form, fieldSubForm],
  components: { FieldSelectOptions },
  watch: {
    fieldType() {
      this.checkFetchOptions()
    },
  },
  mounted() {
    this.checkFetchOptions()
  },
  data() {
    return {
      loading: false,
      allowedValues: ['select_options'],
      values: {
        select_options: [],
      },
    }
  },
  methods: {
    isFormValid() {
      this.$refs.selectOptions.v$.$touch()
      return !this.$refs.selectOptions.v$.$invalid
    },
    checkFetchOptions() {
      if (
        this.fieldType &&
        this.defaultValues.type &&
        this.defaultValues.type !== this.fieldType &&
        this.$registry
          .get('field', this.defaultValues.type)
          .shouldFetchFieldSelectOptions()
      ) {
        this.fetchOptions()
      }
    },
    async fetchOptions() {
      this.loading = true
      const splitCommaSeparated = this.$registry
        .get('field', this.fieldType)
        .acceptSplitCommaSeparatedSelectOptions()
      this.values.select_options = []
      const usedColors = []
      try {
        const { data } = await FieldService(this.$client).getUniqueRowValues(
          this.defaultValues.id,
          this.$config.public.grouperUniqueRowValuesSizeLimit,
          splitCommaSeparated
        )
        for (const value of data.values) {
          const color = randomColor(usedColors)
          usedColors.push(color)
          this.values.select_options.push({
            value,
            color,
          })
        }
      } catch (e) {
        notifyIf(e)
      }
      this.loading = false
    },
  },
}
